import Button from 'components/utils/Button';
import { CustomToast } from 'components/utils/toast-message';
import { Body1 } from 'components/utils/typo';
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

export const CopyLink = ({ link }) => {
  const [buttonText, setButtonText] = useState('Copy');

  const copySuccess = () => {
    toast.success(CustomToast, { data: 'Link is copied into the clipboard' });
    setButtonText('Copied!');
  };

  return (
    <>
      <Body1 className='font-bold'>Copy Link</Body1>
      <div className='mt-2 flex items-center gap-1'>
        <div className='flex grow items-center self-stretch rounded border border-gray-500 px-[10px]'>
          {link}
        </div>
        <CopyToClipboard text={link} onCopy={copySuccess}>
          <Button className='max-w-[100px]'>{buttonText}</Button>
        </CopyToClipboard>
      </div>
    </>
  );
};
